import React from "react";
import { useNavigate } from "react-router-dom";
import { useCreateManufacturerMutation } from "../../redux/api/manufacturersApi";
import ManufacturerForm from "./ManufacturerForm";
import { toast } from "react-toastify";

const AddManufacturerPage = () => {
  const navigate = useNavigate();
  const [createManufacturer, { isLoading }] = useCreateManufacturerMutation();

  const handleAddManufacturer = async (formData) => {
    try {
      await createManufacturer(formData).unwrap();
      toast.success("Manufacturer created successfully!");
      navigate("/manufacturers");
    } catch (err) {
      toast.error(err?.data?.message || err?.error || "Failed to create manufacturer");
    }
  };

  return (
    <div>
      <h1 className="mb-4">Add Manufacturer</h1>
      <ManufacturerForm onSubmit={handleAddManufacturer} loading={isLoading} />
    </div>
  );
};

export default AddManufacturerPage;
